export const category = {
'Space Exploration': 0,
'Wearables': 1,
'Hardware': 2,
'Software': 3,
'Web': 4,
'Sound': 5,
"Children's Books": 6,
'Calendars': 7,
'Art Books': 8,
'Fiction': 9,
'Nature': 10,
'People': 11,
'Letterpress': 12,
'Literary Journals': 13,
'Nonfiction': 14,
'Footwear': 15,
'Jewelry': 16,
'Pet Fashion': 17,
'Ready-to-wear': 18,
'Apparel': 19,
'Animation': 20,
'Comedy': 21,
'Documentary': 22,
'Action': 23,
'Textiles': 24,
'Sculpture': 25,
'Public Art': 26,
'Performance Art': 27,
'Crafts': 28,
'DIY': 29,
'Woodworking': 30,
'Knitting': 31,
'Candles': 32,
'Quilts': 33,
'Glass': 34,
'Embroidery': 35,
'Crochet': 36,
'Pottery': 37,
'Product Design': 38,
'Graphic Design': 39,
'Design': 40,
'Typography': 41,
'Interactive Design': 42,
'Civic Design': 43,
'Architecture': 44,
'Shorts': 45,
'Narrative Film': 46,
'Film & Video': 47,
'Webseries': 48,
'Thrillers': 49,
'Family': 50,
'Experimental': 51,
'Science Fiction': 52,
'Fantasy': 53,
'Music Videos': 54,
'Horror': 55,
'Movie Theaters': 56,
'Drama': 57,
'Romance': 58,
'Television': 59,
'Festivals': 60,
'Food': 61,
'Small Batch': 62,
"Farmer's Markets": 63,
'Restaurants': 64,
'Farms': 65,
'Drinks': 66,
'Events': 67,
'Food Trucks': 68,
'Cookbooks': 69,
'Vegan': 70,
'Spaces': 71,
'Community Gardens': 72,
'Bacon': 73,
'Fashion': 74,
'Accessories': 75,
'Couture': 76,
'Childrenswear': 77,
'Places': 78,
'Digital Art': 79,
'Flight': 80,
'Graphic Novels': 81,
'Dance': 82,
'R&B': 83,
'Performances': 84,
'Gaming Hardware': 85,
'Mobile Games': 86,
'Gadgets': 87,
'Young Adult': 88,
'Illustration': 89,
'Translations': 90,
'Zines': 91,
'Weaving': 92,
'Ceramics': 93,
'Radio & Podcasts': 94,
'Immersive': 95,
'Technology': 96,
'Blues': 97,
'DIY Electronics': 98,
'Jazz': 99,
'Electronic Music': 100,
'Apps': 101,
'Camera Equipment': 102,
'Robots': 103,
'3D Printing': 104,
'Workshops': 105,
'Poetry': 106,
'Photobooks': 107,
'Photography': 108,
'World Music': 109,
'Mixed Media': 110,
'Residencies': 111,
'Fine Art': 112,
'Classical Music': 113,
'Printing': 114,
'Webcomics': 115,
'Animals': 116,
'Publishing': 117,
'Kids': 118,
'Academic': 119,
'Periodicals': 120,
'Anthologies': 121,
'Indie Rock': 122,
'Comic Books': 123,
'Games': 124,
'Tabletop Games': 125,
'Installations': 126,
'Conceptual Art': 127,
'Playing Cards': 128,
'Puzzles': 129,
'Metal': 130,
'Video Games': 131,
'Photo': 132,
'Pop': 133,
'Rock': 134,
'Country & Folk': 135,
'Print': 136,
'Video': 137,
'Latin': 138,
'Faith': 139,
'Art': 140,
'Painting': 141,
'Video Art': 142,
'Makerspaces': 143,
'Hip-Hop': 144,
'Music': 145,
'Stationery': 146,
'Punk': 147,
'Fabrication Tools': 148,
'Chiptune': 149,
'Musical': 150,
'Theater': 151,
'Comics': 152,
'Plays': 153,
'Journalism': 154,
'Audio': 155,
'Literary Spaces': 156,
'Live Games': 157,
'Taxidermy': 158,
}

export const countries = {
'United States': 0,
'Great Britain': 1,
'Australia': 2,
'Spain': 3,
'France': 4,
'Canada': 5,
'Germany': 6,
'Italy': 7,
'Netherlands': 8,
'Switzerland': 9,
'Denmark': 10,
'Norway': 11,
'Ireland': 12,
'Sweden': 13,
'Belgium': 14,
'Austria': 15,
'New Zealand': 16,
'Luxembourg': 17,
'Singapore': 18,
'Mexico': 19,
'Hong Kong': 20,
'Japan': 21,
}